import { Local, Category_Time , Section_Time } from './../../services/question.service';
import { Component, OnInit, Renderer2, HostListener, ViewChild, ElementRef, TemplateRef, Inject, NgZone, Injectable,Input } from '@angular/core';
import { DomSanitizer ,  SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatIconRegistry } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/observable/timer'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/take'
import { Pipe, PipeTransform } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import * as _ from 'lodash';
import { formatDate } from '@angular/common';
import * as moment from 'moment';
import Swal from 'sweetalert2';


import {
  faFilter,
  faPauseCircle,
  faHome,
  faAngleLeft,
  faAngleRight,
  faInfoCircle,
  faPencilAlt
} from '@fortawesome/free-solid-svg-icons';
import { Router, ActivatedRoute, CanActivate } from '@angular/router';
import { Question, questionService } from 'src/app/services/question.service';
import { FormControl, FormGroup } from '@angular/forms';
import { SaveModel, SaveEssay } from './urltest.model';
import { LocationStrategy } from '@angular/common';
// import { DraggableComponent } from '../draggable/draggable.component';
import { ConfigService, evaluate_user } from 'src/app/services/config.service';
import { endtestService, Endtest, Check_log_value } from 'src/app/services/endtest.service';


declare var $: any;
declare let jQuery: any;

@Component({
  selector: 'app-urltest',
  templateUrl: './urltest.component.html',
  styleUrls: ['./urltest.component.scss'],

  
  styles: [
    `.redClass { background-color: red }
    `
  ]
})
@Injectable()
export class UrltestComponent implements OnInit {

  
  @ViewChild("content") modalContent: TemplateRef<any>;
  @ViewChild("finish") modalFinish: ElementRef;
  @ViewChild("keyboard") modalKeyboard: TemplateRef<any>;
  @ViewChild("Start") modalStart: TemplateRef<any>;
  @ViewChild("rightclick") modalRightClick: TemplateRef<any>;
  @ViewChild("timeralert") modalTimerAlert: TemplateRef<any>;
  @ViewChild('alert', { static: true }) alert: ElementRef;
  @ViewChild("myroughspace") modalRoughspace: TemplateRef<any>;
  @ViewChild("text") text: ElementRef;
  //@ViewChild(MathjaxComponent) childView: MathjaxComponent;
  @ViewChild('equation') equation: ElementRef;
  @Input(' MathJax')
  @Input('MathJax') fractionString: string;
  elem;
  essay_str = Array<{ essay: string; questionid: number }>();
  save_essay: Array<SaveEssay> = [];
  toggleClass = 'ft-minimize';
  today = new Date();
  todaysDataTime = '';
  public config: any = {};
  eee: boolean;
  input: any;
  func: any;
  textValue: string = '';
  taker_id: any;
  showModal5: boolean;
  showModal1: boolean;
  showModal2: boolean;
  showModal: boolean;
  zero: number = 0;
  n: any;
  caretPos: number = 0;

  // roughspace: boolean=false;
  //word count
  public remainingWords = 5;

  public textareaForm = new FormGroup({
    textinput: new FormControl()
  });
  str: string;
  Fullscreen: any
  buttonclick: boolean = false;
  checked: boolean = false;
  public isEnding: boolean = false;
  public isFiltering: boolean = true;
  section: any[] = [];
  closeResult: string;
  row_question: string;
  season_question: string;
  currentCheckedValue = null;
  cat_Id;
  radio_ques_id;
  radio_ans_id;
  type_ques_id: string;
  essay_id: string;
  sample = 20;
  id;
  set;
  paper;
  unanswered;
  visited_count;
  answered: number = 0;
  question: Question = {
    questionId: '',
    question_text: '',
    answerId: '',
    Answer_Text: '',
    Duration: '',

  };
  check_loggedin: Check_log_value = {
    Test_Taker_User_Id: '',
    schedule_id: ''
  }
  user_id: evaluate_user = {
    id: ''
  };
  // cat_set: Local = {
  //   Id: '',
  //   set: '',
  //   paper: ''
  // };
  temp_ques_id: any;
  questions: any;
  time: number;
  myTime: any;
  total: number;
  answer: any;
  length1: any;
  filter_answer_id: any;
  filter_answer_id1: any;
  category: any;
  questionIdarray = [];
  //submit_final = new Array(this.length1);
  save_answer = Array<{ roughspace: boolean; answerid: number; questionid: number;user_id : number;
  schedule_id : number, username : any}>();
  qid = [];
  // save_answer = Array<{  answerid: number; questionid: number }>();
  // visitedArray= Array<{value:boolean;i:number}>();
  //visitedArrays=Array<{value:boolean;i:number}>();
  visitedArrays: any = [];
  visitedArray: any = [];
  fill: any = [];
  visited: any = [];
  filter = [];
  local: Local = { Id: '', paper: '', set: '', schedule: '', email: '', schedule_master_Id: '' };
  category_time: Category_Time = { start_time: '', end_time: '', category_id: '', user_id: '' };
  section_time: Section_Time = { start_time: '', end_time: '', section_name: '', user_id: '' , email: '' , category_id:''}
  submit: Array<SaveModel> = [];
  fname: any;
  countDown;
  counter;
  tick = 1000;
  cat: any;
  button_click: boolean = true;
  select: any = [];
  islogged: Endtest = {
    Id: '',
    Test_Taker_User_Id: '',
    Is_Logged: '',
    login_time: '',
    logoff_time: '',
    schedule_master_Id: ''
  };
  //save_essay:any=[];
  // public set:any;
  // public paper:any;
  // document: any;
  // modalService: any;
  //text: any;
  words: any = [];
  wordCount: any;
  myvar: boolean = false;
  fCount: number;
  public url: any;
  focuscount: number = 0;
  private fn: Function;
  crt_value: any;
  color: any = 'Violet';
  visited_value: boolean = true;
  i: number = 0;
  temp1 = `q${this.i} `;
  temp = `q${this.questionIdarray} `;
  arrlength: any;
  summa: any;
  section_button: any;
  roughspace: any;
  roughspace_filter: any = [];
  book_mark : any = [];
  end_button: any = [];
  start_time: string;
  category_start_time: string;
  arr: any;
  essay_ques_length: any;
  length: any;
  essay: boolean;
  audio_flag: boolean;
  video_flag: boolean;
  youtube_flag: boolean;
  video_id : string;
  not_essay: boolean;
  ques_index: any;
  esarr = [];
  wordc: any;
  roughspace_filter1: any = [];
  visit: any = 1;
  total_questions;
  stopblink: boolean;
  base64Image: any;
  thumbnail: any;
  sanitizer: any;
  dir: any;
  sectioncount: any;
  sectioncounter: any;
  keypress: boolean = false;
  delkeypress: boolean = false;
  lastPos: number = 0;
  user_logon_time: string;
  user_loggoff_time: string;
  logged: boolean;
  timer: any;
  timer_alert: number;
  timing: number;
  hourglass: boolean = false;
  timings: any;
  fractionString1: any = [];
  modalRef: any;
  modalCafe: any;
  displayname: string;
  categoryduration: any;
  escapetime: number;
  escape_count: number = 0;
  popupcounter: number = 0;
  pagealive: number = 0;
  datenow: number;
  date: Date;
  // temp1 = `q${this.i} `;
  // Kill subject to stop all requests for component
  private killTrigger: Subject<void> = new Subject();
  question_length: any;
  code_Pos: number;
  code_tabpress: number = 0;
  Section_Id: any;
  first_question: any;
  tab_counter: number =0;
  userId: string;
  email: string;
  schedule_id: string;
  bookmark_counter: number = 0;
  questioncounter: boolean = false;
  products: { category_Id: number; ProductId: number; Product_name: string; }[];
  answer_text: any;
  q_url: any;
  media_url:any;
  safeSrc: SafeResourceUrl;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private ren: Renderer2,
    private location: LocationStrategy,
    private route: ActivatedRoute,
    private quest: questionService,
    public router: Router,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private httpClient: HttpClient,
    private modal: NgbModal,
    private ngZone: NgZone,
    private modalService: NgbModal,
    private config1: ConfigService,
    private evaluate_user: endtestService,
    private Endtest: endtestService,
    private el: ElementRef,
    private _sanitizer: DomSanitizer

  ) {

    iconRegistry.addSvgIcon(
      'thumbs-up',
      sanitizer.bypassSecurityTrustResourceUrl('assets/filter_list.svg')
    );

    
    
  }
  canActivate(route: import("@angular/router").ActivatedRouteSnapshot, state: import("@angular/router").RouterStateSnapshot): boolean | import("@angular/router").UrlTree | Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {
    throw new Error("Method not implemented.");
  }
  public ngOnInit() {
    console.log("inside urltest")
    const self = this;

    this.escapetime = 80000;
    this.sectioncount = JSON.parse(localStorage.getItem('section_counter'));
    this.fname = sessionStorage.getItem('fname');

    MathJax.Hub.Config({
      showMathMenu: false,
      tex2jax: { inlineMath: [['$', '$'], ['\\(', '\\)']] },
      menuSettings: { zoom: "Double-Click", zscale: "150%" },
      CommonHTML: { linebreaks: { automatic: true } },
      "HTML-CSS": { scale: 100, linebreaks: { automatic: true, width: "container" } },
      SVG: { linebreaks: { automatic: true } }
    });
    setTimeout(() => {
      MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("answers")]);
    }, 1000)



    jQuery(document).ready(function ($) {

      if (window.history && window.history.pushState) {

        $(window).on('popstate', function () {
          var hashLocation = location.hash;
          var hashSplit = hashLocation.split("#!/");
          var hashName = hashSplit[1];

          if (hashName !== '') {
            var hash = window.location.hash;
            if (hash === '') {
            }
          }
        });

        window.history.pushState('/', null, './');
      }

    });

    $(window).unload(function () {
      Swal.fire({
        title: 'Alert',
        text: 'Unload ',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'OK'
      }).then((result) => {
        if (result.isConfirmed) {
        }
      })
    });


    // const modalRef = this.modal.open(this.modalContent)

    this.elem = document.documentElement;
    this.route.params.subscribe(params => {
      this.Section_Id = params['id'];
      this.set = localStorage.getItem('Set-id');
      this.paper = localStorage.getItem('Paper-id');
    });


    this.displayname = localStorage.getItem('display_name');
    this.categoryduration = localStorage.getItem('categoryduration');
    this.local.Id = this.Section_Id
    this.local.set = sessionStorage.getItem('Set_Id')
    this.local.paper = sessionStorage.getItem('Paper_Id')
    this.local.schedule = sessionStorage.getItem('Schedule_Id')
    this.local.email = sessionStorage.getItem('email')
    this.local.schedule_master_Id = sessionStorage.getItem('Schedule_Master_Id');
    this.displayQuestions();
   
    this.timer = this.categoryduration
    this.timer_alert = (this.timer - 2) * 60000;
    this.time = this.categoryduration * 60000;
    this.counter = this.categoryduration * 60;
    this.myTime = null;
        this.timings = null;
        this.timings = setTimeout(() => {
          let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false
          };
          //Open modal on pressing escape
          const modalRef = this.modal.open(this.modalTimerAlert, ngbModalOptions)
          setTimeout(() => {
            modalRef.close(this.modalTimerAlert)
          }, 8000);
        }, this.timer_alert);
        this.myTime = setTimeout(() => {


          clearTimeout(this.escapetime);
          this.escapetime = 0;

        
            // this.end_test();
          this.submit_test();

          //this.modalRef.close(this.modalFinish);
          this.router.navigate(['section']);
          this.modalCafe.close(this.modalContent)
        }, this.time);
        //},20000);
        this.countDown = Observable.timer(0, this.tick)
          .take(this.counter)
          .map(() => --this.counter)
  }

  

  displayQuestions(){
    this.quest.displayQuestion(this.local).subscribe(
      data => {
        this.questions = data.results;
        console.log(this.questions[0].Id);
        
        this.quest.displayurl(this.questions[0].Id).subscribe(
          data => {
            this.q_url = data.results;
            console.log(this.q_url[0].q_url);
            if ((this.q_url[0].q_url.indexOf('.mp3') > -1) || (this.q_url[0].q_url.indexOf('.wav') > -1) || (this.q_url[0].q_url.indexOf('.ogg') > -1) )
                this.audio_flag = true;

            if ((this.q_url[0].q_url.indexOf('www.youtube.com') > -1) )
            {
              this.youtube_flag = true;
            this.video_id='https://www.youtube.com/embed/' + this.youtube_parser(this.q_url[0].q_url);
            console.log(this.video_id);

            this.safeSrc =  this._sanitizer.bypassSecurityTrustResourceUrl(this.video_id);
          
            }
            
           
            

          }
          );
        this.first_question = this.questions[0];
        this.question_length = this.questions.length;
        for (var i = 0; i < data.results.length; i++) {
          this.fractionString1.push(data.results[i].Question_Text)
        }
        this.total_questions = this.questions.length;
        if(this.total_questions > 29){
          this.questioncounter = true
        }

          this.not_essay = true;
        
        this.length1 = this.questions.length;
        for (var i = 0; i < this.length1; i++) {
          this.esarr[this.questions[i].Id] = null
        }
        this.answer = data.resultanss;
        this.getCategory(this.questions[0].Question_Id)
        this.visited_count = this.length1 - 1;
        this.category = this.questions[0].Category_Name;
        this.total = this.questions.length;
        this.userId = sessionStorage.getItem('id');
        this.email = sessionStorage.getItem('email');
        this.schedule_id = sessionStorage.getItem('Schedule_Id');
        for (var i = 0; i < this.length1; i++) {
          this.questionIdarray[i] = this.questions[i].Id;
        }

        for (var i = 0; i < this.length1; i++) {

          var temp = `q${this.questionIdarray[i]} `;

          this.save_answer[temp] = [null, null, this.questionIdarray[i],this.userId,this.schedule_id,this.email];
        }
        for (var i = 0; i < this.length1; i++) {

          var temp = `q${this.questionIdarray[i]} `;

          this.essay_str[temp] = [null, this.questionIdarray[i]];



        }
        for (var i = 0; i < this.length1; i++) {

          this.filter[this.questionIdarray[i]] = false;


        }
        this.unanswered = this.length1;


        return this.questions, this.questionIdarray;

      },
      err => {
        console.error(err);
      }
    );
    

  }

  
  getCategory(id){
    this.answer_text = this.answer.filter(p=>p.Question_Id==id)
    return this.answer.filter(p=>p.Question_Id==id);
  }

  @HostListener('window:blur', ['$event'])
  onBlur(event: any): void {
    this.popupcounter = this.popupcounter + 1

    if (this.popupcounter <= 2) {
      this.modalRef = this.modal.open(this.modalStart)
      setTimeout(() => {
        this.modalRef.close(this.modalStart)
      }, 3000);

    }

  }

  update() {
    MathJax.Hub.Config({
      showMathMenu: false,
      // jax: ["input/TeX", "output/HTML-CSS"],
      tex2jax: {
        inlineMath: [['$', '$'], ['\\(', '\\)']],
        //processEscapes: true,
        // skipTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code']
      },
      menuSettings: { zoom: "Double-Click", zscale: "20%" },
      CommonHTML: { linebreaks: { automatic: true } },
      "HTML-CSS": { scale: 100, linebreaks: { automatic: true, width: "container" } },
      SVG: { linebreaks: { automatic: true } }
    });
    setTimeout(() => {
      MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("answers")]);
    }, 1000)


  }
  //check textarea for roughspace indicator
  textAreaEmpty(row, i) {


    if (row.textValue != '') {


      // j=i
      //
      this.roughspace_filter[row.Id] = true
    }


  }


    //get co-ordinates in essay-textarea
  getCaretPos(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPos = oField.selectionStart;
    }

  }

  //open roughwork space
  openroughspace() {
    if (this.myvar == true) {
      //this.myvar = false;
    }
    else {
      this.myvar = true;
    }
  }


  faFilter = faFilter;
  faPauseCircle = faPauseCircle;
  faHome = faHome;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faInfoCircle = faInfoCircle;
  faPencilAlt = faPencilAlt;

  //Filter color

  getcolor(row, i) {
    //
    //
    //
    let color = 'red';
    if (i == 0 && this.fill[0] == null) {
      color = '#F9C118'
    }
    if (this.button_click == true && i != 0) {
      color = 'red'
      this.button_click = false;
    }
    if (this.visited[i] == true && this.fill[row.Id] == null || this.roughspace_filter1[row.Id] == false) {
      color = '#F9C118'
    }
    if (this.fill[row.Id] != null && this.visited[i] == true || this.roughspace_filter1[row.Id] == true) {
      color = 'green'
    }
    if(this.book_mark[row.Id] == true ){
      color = '#7000a0'
    }
    return color;
  }



  //visited function
  visit_func(i) {
    this.visitedArray = i

    // this.save_essay=this.essay_str
    //
    // this.essayAreaEmpty(questionIdarray, i);
    let success = (!this.visitedArrays.some((item) => item == this.visitedArray))
    {


      this.visitedArrays.push(this.visitedArray)
      _.uniq(this.visitedArrays);


    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }
    return

  }


  //get category end time

  end_time() {

    // this.todaysDataTime = formatDate(this.today, 'hh:mm', 'en-US', '+0530');
    var now = moment().format("hh:mm:ss");

    this.date = new Date()



    this.end_button = now

  }


  //disable browser backbutton
  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose(event: Event) {


    event.preventDefault();
    //window.history.forward();
    this.router.navigate(['/'], { replaceUrl: true });
  }

  

  onselect(row, i) {
    this.selectedIndex = i;
    this.visitedArray = i;
    this.tab_counter = this.tab_counter+1;
    if (this.tab_counter == 1 && this.fill[this.first_question.Id] != null) {
      this.visited[0] = true;
      this.visit_func(0)
      this.getcolor(this.first_question, 0);
    }
    this.visited[i] = true
    let success = (!this.visitedArrays.some((item) => item == this.visitedArray))
    {
      this.visitedArrays.push(this.visitedArray)
      _.uniq(this.visitedArrays);
    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {

        this.stopblink = true;
      }
    }



    this.submit = this.save_answer;
    for (let i in this.submit) {
      this.fill[this.submit[i][2]] = this.submit[i][1]
    }
    this.getCategory(row.Id)
    this.router.navigate(['urltest', row.Id]);

  }

  favoriteSeason: string;
  check;

  checkState(el, season, button) {

    // alert(el.value)
    this.season_question = season.Question_Id;
    console.log(this.season_question)

    setTimeout(() => {

      if (this.currentCheckedValue === el.value) {

        el.checked = false;
        this.check = el.checked;

        this.ren.removeClass(el['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(
          el['_elementRef'].nativeElement,
          'cdk-program-focused'
        );
        this.currentCheckedValue = null;
        this.favoriteSeason = null;

      } else {
        this.currentCheckedValue = el.value;
      }

      this.filter_answer_id = season.Question_Id;

      this.filter[this.filter_answer_id] = el.checked;



      for (let i in this.filter)

      this.radio_ques_id = season.Question_Id;

      this.filter_answer_id = season.Question_Id;

      this.radio_ans_id = el.value;

      this.type_ques_id = `q${this.radio_ques_id} `;
      if ((this.filter[this.filter_answer_id] == true) && (this.roughspace_filter[season.Question_Id] == true)) {

        this.save_answer[this.type_ques_id] = [
          1,
          this.radio_ans_id,
          this.radio_ques_id,
          this.userId,
          this.schedule_id,
          this.email
        ];
        console.log(this.save_answer[this.type_ques_id]);
      } else if ((this.roughspace_filter[season.Question_Id] == true) && (this.filter[this.filter_answer_id] == false)) {
        this.save_answer[this.type_ques_id] = [
          1,
          null,
          this.radio_ques_id,
          this.userId,
          this.schedule_id,
          this.email
        ]
        console.log(this.save_answer[this.type_ques_id]);
      } else if ((this.roughspace_filter[season.Question_Id] == null) && (this.filter[this.filter_answer_id] == true)) {
        this.save_answer[this.type_ques_id] = [
          null,
          this.radio_ans_id,
          this.radio_ques_id,
          this.userId,
          this.schedule_id,
          this.email
        ]
        console.log(this.save_answer[this.type_ques_id]);
      }
      else {

        var a = this.type_ques_id;

        this.save_answer[this.type_ques_id] = [null, null, this.radio_ques_id,this.userId,this.schedule_id,this.email];
        console.log(this.save_answer[this.type_ques_id]);
      }


      this.submit = this.save_answer;


      this.unanswered = this.length1;
      for (var i = 0; i < this.length1; i++) {

        if (this.filter[this.questionIdarray[i]] == true) {
          this.unanswered = this.unanswered - 1;
        }
      }

      for (let i in this.submit) {

        this.fill[this.submit[i][2]] = this.submit[i][1];

      }
      this.answered = this.total - this.unanswered;

    });
  }


  //next button
  maxNumberOfTabs: number;
  selectedIndex: number = 0;

  nextStep(questionIdarray, i) {
    //  this.button_click=false;
    this.selectedIndex = i;
    this.maxNumberOfTabs = this.length1;


    //this.submit = this.save_answer;

    this.visitedArray = i+1

    // this.save_essay=this.essay_str
    //
    // this.essayAreaEmpty(questionIdarray, i);
    let success = (!this.visitedArrays.some((item) => item == this.visitedArray))
    {


      this.visitedArrays.push(this.visitedArray)
      _.uniq(this.visitedArrays);


    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }

    this.visited[i + 1] = true;
    this.visited[i] = true;

    //   if(this.visited[i]==true && this.visited_count>0){
    //      this.visited_count=this.visited_count-1;
    //      this.visited_value[i]=false;
    //   }

    //
    //
    //

    for (let i in this.submit) {

      this.fill[this.submit[i][2]] = this.submit[i][1];





    }

    if (this.selectedIndex != this.length1) {
      this.selectedIndex = this.selectedIndex + 1;
    }
    this.getCategory(questionIdarray[this.selectedIndex])
    // this.quest.displayAnswer(questionIdarray[this.selectedIndex]).subscribe(
    //   async data => {

    //
    //     this.answer = data.resultanss;

    //     return this.questions, this.maxNumberOfTabs;
    //     return this.answer;
    //   },
    //   err => {
    //     console.error(err);
    //   }
    // );

    this.router.navigate(['urltest', questionIdarray[i]]);
  }


  previousStep(questionIdarray, i) {
    // this.button_click=false;
    this.selectedIndex = i;

    if (this.selectedIndex != 0) {
      this.selectedIndex = this.selectedIndex - 1;
    }
    this.visited[i - 1] = true;
    this.visited[i] = true;
    this.visitedArray = i-1;

    let success = (!this.visitedArrays.some((item) => item == this.visitedArray))
    {


      this.visitedArrays.push(this.visitedArray)
      _.uniq(this.visitedArrays);


    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }

    }

    for (let i in this.submit) {

      this.fill[this.submit[i][2]] = this.submit[i][1];

    }
    this.getCategory(questionIdarray[this.selectedIndex])
    this.router.navigate(['urltest', questionIdarray[this.selectedIndex]]);
  }

  // submit answers in user_answer table(all mcq's)
  submit_test() {
    this.end_time();
    // clearInterval(this.intervalId);
    //alert('submitans')
    if (this.sectioncount === null) {
      this.sectioncount = 0;
    }

    this.sectioncount++;
    localStorage.setItem("section_counter", JSON.stringify(this.sectioncount));

    this.category_start_time = sessionStorage.getItem('Start_Time')
    this.category_time.end_time = this.end_button
    this.category_time.start_time = this.category_start_time;
    this.category_time.category_id = this.questions[0].Section_Id;
    this.category_time.user_id = sessionStorage.getItem('Id')

    this.section_time.end_time = this.end_button
    this.section_time.start_time = sessionStorage.getItem('Start_Time')
    this.section_time.section_name = localStorage.getItem('Section_Name');
    this.section_time.user_id = sessionStorage.getItem('id')
    this.section_time.email = sessionStorage.getItem('email')

    clearTimeout(this.myTime);
    this.myTime = 0;
    clearTimeout(this.timings);
    this.timings = 0;

    localStorage['targetSection' + this.questions[0].Section_Id] = 0;
    var tempp = localStorage.getItem(
      'targetSection' + this.questions[0].Section_Id
    );
    localStorage['section_button' + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem('section_button' + this.questions[0].Section_Id);
    this.submit = this.save_answer;
    // this.quest.submit(this.submit).subscribe(
    //   async data => {
    //     console.log("data.code in urltest",data.code)
    //     if(data.code === 200)
    //     {
    //       Swal.fire({
    //         title: 'Success',
    //         text: 'Answers Saved Successfully!',
    //         icon: 'success',
    //         showCancelButton: false,
    //         confirmButtonText: 'OK'
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //         }
    //       })
    //     }else if (data.code === 400) {
    //       Swal.fire({
    //         title: 'Alert',
    //         text: data.failed,
    //         icon: 'warning',
    //         showCancelButton: false,
    //         confirmButtonText: 'OK'
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //           // this.router.navigateByUrl('/test_scheduler');
    //         }
    //       })
    //     }
    //   },
    //   err => {
    //     //console.error(err);

    //   }

    // );

    this.send_time();
    this.sectiontime();

    this.exitFullScreen();
    this.router.navigateByUrl('section');


  }
  
  async sectiontime() {
    // alert("sendtime")
    this.quest.section_time(this.section_time).subscribe(
      async data => {

      },

      err => {
        //console.error(err);

      }
    )
      ;
  }

  //Save section time
  async send_time() {
    // alert("sendtime")
    this.quest.cate_time(this.category_time,this.userId,this.schedule_id,this.email).subscribe(
      async data => {

      },

      err => {
        //console.error(err);

      }
    )
      ;
  }
  
  //submit answers
  async end_test() {
    this.end_time();
    // clearInterval(this.intervalId);
    if (this.sectioncount === null) {
      this.sectioncount = 0;
    }
    this.sectioncount++;

    localStorage.setItem("section_counter", JSON.stringify(this.sectioncount));
    this.category_start_time = sessionStorage.getItem('Start_Time')
    this.category_time.end_time = this.end_button
    this.category_time.start_time = this.category_start_time;
    this.category_time.category_id = this.questions[0].Section_Id;
    this.category_time.user_id = sessionStorage.getItem('Id')

    
    // this.section_time.start_time = sessionStorage.getItem('Start_Time')
    // this.section_time.section_name = localStorage.getItem('Section_Name');
    // this.section_time.user_id = sessionStorage.getItem('Id')

    this.section_time.end_time = this.end_button
    this.section_time.start_time = sessionStorage.getItem('Start_Time')
    this.section_time.section_name = localStorage.getItem('Section_Name');
    this.section_time.user_id = sessionStorage.getItem('id')
    this.section_time.email = sessionStorage.getItem('email')

    localStorage['targetSection' + this.questions[0].Section_Id] = 0;
    var tempp = localStorage.getItem(
      'targetSection' + this.questions[0].Section_Id
    );
    localStorage['section_button' + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem('section_button' + this.questions[0].Section_Id);

    this.submit = this.save_answer;


    // const data = await this.quest.submit(this.submit).toPromise();

    this.send_time();
    this.exitFullScreen();
    this.sectiontime();
    this.router.navigateByUrl('section');


    //this.modalService.dismissAll();



  }

   youtube_parser(url){
    var regExp = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
    var match = url.match(regExp);
    return (match && match[1].length==11)? match[1] : false;
   }


  //capture right click event and display warning msg
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
    const modalRef = this.modal.open(this.modalRightClick)
    setTimeout(() => {
      modalRef.close(this.modalContent)
    }, 3000);
    setTimeout(() => {
      modalRef.close(this.modalRightClick)
    }, 3000);
  }


  //Track fullscreen change
  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])


  fullscreenmode(event) {
    event.preventDefault()
    if (window.innerHeight == screen.height) {

    }


    if (this.toggleClass == 'ft-minimize') {

      this.toggleClass = 'ft-maximize';


      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false
      };

      //Open modal on pressing escape

      this.modalCafe = this.modal.open(this.modalContent, ngbModalOptions)
      this.escape_count = this.escape_count + 1;
      if (this.escape_count > 6 || this.popupcounter > 6) {
        this.modalCafe.close(this.modalContent)
        clearTimeout(this.escapetime);
        this.escapetime = 0;
        this.n = JSON.parse(localStorage.getItem('on_load_counter'));
        localStorage.setItem('on_load_counter', JSON.stringify(this.zero));
        this.submit_test();
        this.final()
        this.modalCafe.close(this.modalContent)
        this.router.navigateByUrl('final');



      }
      setTimeout(() => {

        clearTimeout(this.escapetime);
        this.escapetime = 0;

        if (this.buttonclick == false) {
          this.modalCafe.close(this.modalContent)

          this.n = JSON.parse(localStorage.getItem('on_load_counter'));
          localStorage.setItem('on_load_counter', JSON.stringify(this.zero));
          this.submit_test();
          this.modalCafe.close(this.modalContent)
          this.final()
          this.router.navigateByUrl('final');

        }

      }, this.escapetime);

    }
    else {
      this.toggleClass = 'ft-minimize';


    }
  }

  //endtest for malpracticed users
  final() {
    localStorage.setItem('on_load_counter', JSON.stringify(this.zero));
    this.n = 0;
    localStorage.setItem("section_counter", JSON.stringify(this.zero));

    this.user_logon_time = localStorage.getItem('Logon time');
    this.todaysDataTime = formatDate(this.today, 'hh:mm:ss', 'en-US', '+0530');

    this.user_loggoff_time = this.todaysDataTime

    this.islogged.login_time = this.user_logon_time;
    this.islogged.logoff_time = this.user_loggoff_time;
    var schedule_master = sessionStorage.getItem('Schedule_Master_Id')

    this.Endtest.endtest(this.islogged,this.userId,schedule_master).subscribe(

      data1 => {

        this.logged = true;
        this.evaluate()

      },
      err => {
        //console.error(err);

      }

    );


  }

  //evaluate malpracticed users
  evaluate() {
    console.log("inside evaluate**",this.userId,this.schedule_id)


    this.evaluate_user.evaluate(this.userId,this.schedule_id).subscribe(
      data => {
       //this.end_time();
      },
      err => {
        //console.error(err);
      }
    );
  }

  //Open fullscreen
  openFullscreen() {
    this.buttonclick = true;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  //exitfullscreen
  exitFullScreen() {
    const document: any = window.document;
    if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }

  // Observable to collect information from an api
  fetchData() {
    this.check_loggedin.Test_Taker_User_Id = sessionStorage.getItem('id');
    this.check_loggedin.schedule_id = sessionStorage.getItem('Schedule_Id');
    this.Endtest.checkisLogged(this.check_loggedin).subscribe(
      data => {
        if (data.results[0].Is_terminated == 'YES') {
          // clearInterval(this.intervalId);
          // clearImmediate(this.intervalId);
          clearTimeout(this.intervalId);
          this.n = JSON.parse(localStorage.getItem('on_load_counter'));
          localStorage.setItem('on_load_counter', JSON.stringify(this.zero));
          this.submit_test();
          this.final()
          this.modalCafe.close(this.modalContent)
          this.router.navigateByUrl('final');
        }
      },
      err => {
        //console.error(err);
      }
    );
  }

  intervalId = setTimeout(() => {
    this.fetchData()
  }, 30000);

  bookmark(questionIdarray,i){
    this.bookmark_counter = this.bookmark_counter + 1;
     this.book_mark[questionIdarray[i]] = true;

  }

  remove_bookmark(questionIdarray,i){
    this.bookmark_counter = this.bookmark_counter - 1;
    this.book_mark[questionIdarray[i]] = false;
  }
}

//Time Countdown
@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);


    return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
  }

}
